/* SAPSAN - strona kolekcji: „Czytaj dalej”, filtry (rozwijane na komputerze, panel od dołu na telefonie), sortowanie, „Pokaż kolejne”.
   Bez tego pliku wszystko działa: filtry i sortowanie to zwykły formularz GET, kolejne strony to linki ?page=N. */
(function () {
  'use strict';
  var desktop = window.matchMedia('(min-width: 990px)');
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function onMq(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }

  /* ---- opis górny: 2 linie + „Czytaj dalej” (tekst cały czas jest w HTML) ---- */
  qsa('[data-sc-lead]').forEach(function (lead) {
    var text = qs('.sc-lead__text', lead);
    var btn = qs('[data-sc-lead-btn]', lead);
    if (!text || !btn) return;
    var check = function () {
      if (lead.classList.contains('is-open')) return;
      btn.hidden = !(text.scrollHeight > text.clientHeight + 2);
    };
    check();
    window.addEventListener('resize', check, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
    btn.addEventListener('click', function () {
      var open = lead.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      qs('[data-more]', btn).hidden = open;
      qs('[data-less]', btn).hidden = !open;
    });
  });

  /* ---- filtry i sortowanie ---- */
  qsa('[data-sc-form]').forEach(function (form) {
    var groups = qsa('[data-sc-fg]', form);
    var sheet = qs('[data-sc-sheet]', form);
    var openBtn = qs('[data-sc-open]', form);
    var scrim = null;
    var lastFocus = null;

    var bar = form.closest('[data-sc-bar]');
    var clean = function () {
      qsa('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
      var sort = qs('[data-sc-sort]', form);
      if (sort && sort.value === sort.getAttribute('data-default')) sort.disabled = true;
    };
    var submit = function () { clean(); form.submit(); };
    form.addEventListener('submit', clean);

    /* klik w napis „Sortuj” obok pola otwiera listę (showPicker), a nie tylko ustawia fokus - 25.09.2026 */
    var sortLab = qs('.sc-sort', form);
    if (sortLab) sortLab.addEventListener('click', function (e) {
      var s = qs('[data-sc-sort]', sortLab);
      if (!s || e.target === s || typeof s.showPicker !== 'function') return;
      e.preventDefault();
      try { s.showPicker(); } catch (err) { s.focus(); }
    });

    form.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-sc-sort]')) { submit(); return; }
      if (el.type === 'number') return;          /* cena: przycisk „Zastosuj” albo „Pokaż wyniki” */
      if (desktop.matches) submit();             /* komputer: od razu; telefon: po „Pokaż wyniki” */
    });

    groups.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open && desktop.matches) groups.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!desktop.matches) return;
      groups.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });

    var closeSheet = function () {
      if (!sheet || !sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      sheet.removeAttribute('role');
      sheet.removeAttribute('aria-modal');
      document.documentElement.classList.remove('sc-lock');
      if (bar) bar.classList.remove('is-sheet');
      if (scrim) { scrim.remove(); scrim = null; }
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    var openSheet = function () {
      if (!sheet || desktop.matches) return;
      lastFocus = document.activeElement;
      scrim = document.createElement('div');
      scrim.className = 'sc-scrim';
      scrim.addEventListener('click', closeSheet);
      if (bar) { bar.classList.add('is-sheet'); bar.appendChild(scrim); } else document.body.appendChild(scrim);
      groups.forEach(function (d) { d.open = true; });
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      sheet.classList.add('is-open');
      document.documentElement.classList.add('sc-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var x = qs('[data-sc-close]', sheet);
      if (x) x.focus();
    };
    if (openBtn) openBtn.addEventListener('click', openSheet);
    qsa('[data-sc-close]', form).forEach(function (b) { b.addEventListener('click', closeSheet); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (sheet && sheet.classList.contains('is-open')) { closeSheet(); return; }
      groups.forEach(function (d) {
        if (d.open && desktop.matches) { d.open = false; var s = qs('summary', d); if (s) s.focus(); }
      });
    });
    onMq(desktop, function () {
      closeSheet();
      if (desktop.matches) groups.forEach(function (d) { d.open = false; });
    });
  });

  /* ---- „Pokaż kolejne”: dociąga następną stronę (Section Rendering API), linki ?page=N zostają dla robotów ---- */
  qsa('[data-sc]').forEach(function (root) {
    var btn = qs('[data-sc-more]', root);
    if (!btn || !window.fetch || !window.DOMParser) return;
    var sectionId = root.getAttribute('data-section');
    var grid = qs('[data-sc-grid]', root);
    var rest = qs('[data-sc-rest]', root);
    var restList = qs('[data-sc-rest-list]', root);
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var next = btn.getAttribute('data-next');
      if (!next || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var n = qsa('.sc-cell', grid).length;
          var newGrid = qs('[data-sc-grid]', doc);
          if (newGrid && grid) qsa('.sc-cell', newGrid).forEach(function (cell) { n += 1; cell.style.setProperty('--o', String(n * 10)); grid.appendChild(cell); });
          var newRest = qs('[data-sc-rest-list]', doc);
          if (newRest && restList) {
            qsa('li', newRest).forEach(function (li) { if (li.parentNode === newRest) restList.appendChild(li); });
            if (restList.children.length && rest) rest.hidden = false;
          }
          var info = qs('[data-sc-info]', root), newInfo = qs('[data-sc-info]', doc);
          if (info && newInfo) info.textContent = newInfo.textContent;
          var pager = qs('[data-sc-pager]', root), newPager = qs('[data-sc-pager]', doc);
          if (pager && newPager) pager.replaceWith(newPager);
          var newBtn = qs('[data-sc-more]', doc);
          if (newBtn) btn.setAttribute('data-next', newBtn.getAttribute('data-next'));
          else btn.remove();
          if (window.history && history.replaceState) history.replaceState(history.state, '', next);
        })
        .catch(function () { window.location.href = next; })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  });
})();
